document.addEventListener("DOMContentLoaded", function () {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("fade-in-item--faded-in", "js-faded-in");
          observer.unobserve(entry.target); // Stop observing once faded in
        }
      });
    },
    {
      rootMargin: "0px 0px -100px 0px",
    }
  );

  // Initial observation of existing elements
  document.querySelectorAll(".js-fade-in").forEach((elem) => {
    observer.observe(elem);
  });

  // Watch for dynamically added elements
  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.classList && node.classList.contains('js-fade-in')) {
          observer.observe(node);
        }
      });
    });
  });

  // Start observing the document for added nodes
  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});